import { UnixDuration } from '@sparkdotfi/common-universal'

export function formatTimeLeft(timeLeft: UnixDuration): string {
  const timeLeftInSeconds = timeLeft.toSeconds()
  const days = timeLeftInSeconds / UnixDuration({ days: 1 }).toSeconds()
  const hours = (timeLeftInSeconds % UnixDuration({ days: 1 }).toSeconds()) / UnixDuration({ hours: 1 }).toSeconds()
  const minutes = Math.ceil(
    Number(timeLeftInSeconds % UnixDuration({ hours: 1 }).toSeconds()) /
      Number(UnixDuration({ minutes: 1 }).toSeconds()),
  )
  return `${days}D ${hours}H ${minutes}M`
}
